import Container from '@mui/material/Container';
import Skeleton from '../../../componentsv2/Skeleton';

export default function NewInvoiceSkeleton() {
  return (
    <Container sx={{ paddingTop: '40px' }}>
      <Skeleton width="100%" height={400} />
    </Container>
  );
}
